import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getBusiness: async({ dispatch, commit }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            url: '/business',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...params,
                leaderId: params.leader && params.leader.id || null
            }
        })
            .then(res => {
                if (res.data && res.data.businesses) {
                    commit('SET_PAGINATION', {
                        length: res.data.totalPages,
                        page: res.data.page,
                        total: res.data.total
                    })
                    commit('SET_BUSINESS', res.data.businesses)
                    commit('SET_LOAD', false)
                } else if (res.data && params.excel) {
                    downloadBlob(res.data, `Report_${uuid()}.xlsx`)
                    commit('SET_LOAD', false)
                }
            })
    }
}
